import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import Swiper, {
    Navigation,
    Manipulation,
    EffectCoverflow,
    Pagination
} from 'swiper';
import 'swiper/css/bundle';

import './VideoCarousel.scss';

@Component
export class VideoCarousel extends ThemeComponent {
    private navButtons: NodeListOf<HTMLButtonElement>;
    private filters: NodeListOf<HTMLButtonElement>;
    private swiper: Swiper | undefined;

    constructor() {
        super();
        this.navButtons = document.querySelectorAll('.swiper-slider-navigation');
        this.filters = document.querySelectorAll('.success-filter');
    }

    init() {
        const slides: NodeListOf<HTMLElement> = document.querySelectorAll('.video-wrapper .swiper-slide');
        const middleIndex = Math.floor(slides.length / 2);

        this.swiper = new Swiper('.video-swiper', {
            modules: [Navigation, Manipulation, EffectCoverflow, Pagination],
            effect: 'coverflow',
            grabCursor: true,
            centeredSlides: true,
            initialSlide: middleIndex,
            slidesPerView: 'auto',
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 100,
                modifier: 2,
                slideShadows: false,
            },
            pagination: {
                el: '.video-pagination',
                clickable: true,
            }
        });

        if (this.swiper) {
            this.carouselNavigation(slides, this.navButtons);
            this.filterSelector(slides, this.filters);
            this.applyQueryFilters(slides);
        }
    }

    carouselNavigation(slides: NodeListOf<HTMLElement>, navButtons: NodeListOf<HTMLButtonElement>) {
        for (const button of navButtons) {
            this.$listen(button, 'click', () => {
                if (this.swiper) {
                    const currentSlideIndex = this.swiper.activeIndex;
                    let targetSlideIndex: number = currentSlideIndex;

                    if (button.getAttribute('data-direction') === 'prev') {
                        for (let i = currentSlideIndex - 1; i >= 0; i--) {
                            if (slides[i].classList.contains('hide-overlay')) {
                                targetSlideIndex = i;
                                break;
                            }
                        }
                    } else {
                        for (let i = currentSlideIndex + 1; i < slides.length; i++) {
                            if (slides[i].classList.contains('hide-overlay')) {
                                targetSlideIndex = i;
                                break;
                            }
                        }
                    }
                    if (targetSlideIndex !== currentSlideIndex) {
                        this.swiper.slideTo(targetSlideIndex);
                    }
                }
            });
        }
    }

    filterSelector(slides: NodeListOf<HTMLElement>, filters: NodeListOf<HTMLButtonElement>) {
        for (const filter of filters) {
            this.$listen(filter, 'click', async() => {
                const obj = Array.from(filters)
                    .filter((f) => f.classList.contains('button--active'))
                    .map((f) => f.getAttribute('data-filter'))
                    .filter((attr): attr is string => attr !== null);

                if (obj.length > 0) {
                    this.updateSwiperGallery(slides, obj);
                }
            });
        }
    }

    updateSwiperGallery(slides: NodeListOf<HTMLElement>, filters: string[]) {
        const videoWrapper = document.querySelector('.video-wrapper');
        if (videoWrapper && this.swiper) {
            if (filters[0] === 'all' && filters[1] === 'all') {
                for (const slide of slides) {
                    slide.classList.add('hide-overlay');
                }
                const middleIndex = Math.floor(slides.length / 2);
                this.swiper.slideTo(middleIndex);
            }else {
                for (const slide of slides) {
                    if (slide instanceof HTMLElement) {
                        const mainFilters = slide.dataset.mainFilters?.split(',') || [];
                        const productFilters = slide.dataset.productFilters?.split(',') || [];

                        if (mainFilters.map((item: string) =>
                            item.trim()).includes(filters[0].trim())
                                && productFilters.map((item: string) =>
                                    item.trim()).includes(filters[1].trim())) {

                            slide.classList.add('hide-overlay');

                            const indexToSlide = Array.from(slides).findIndex((slide) =>
                                slide.classList.contains('hide-overlay')
                            );

                            if (indexToSlide >= 0) {
                                this.swiper.slideTo(indexToSlide);
                            }

                        }else {
                            slide.classList.remove('hide-overlay');
                        }
                    }
                }
            }
        }
    }

    applyQueryFilters(slides: NodeListOf<HTMLElement>) {

        const urlParams = new URLSearchParams(window.location.search);
        const successFilter = urlParams.get('type-filter');
        const productFilter = urlParams.get('product-filter');

        if (successFilter && productFilter) {
            this.updateSwiperGallery(slides, [successFilter, productFilter]);
        }
    }
}
